import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-send-email-confirmation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class SendEmailConfirmationComponent {
  emailCount = 0;
  enteredEmailCount: number | null = null;

  constructor(
    @Optional() private readonly dialogRef: MatDialogRef<SendEmailConfirmationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.emailCount = this.data.split(';').filter((i: string) => i).length;
    }
  }

  close() {
    if (this.dialogRef) { this.dialogRef.close(); }
  }

  confirm() {
    if (this.dialogRef) { this.dialogRef.close('confirm'); }
  }

}
